import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import LogsContent from '../../components/Pages/Logs';

const { displayName } = config;

export default function Logs(): React.ReactNode | null {
  document.title = `${displayName}: Logs`;

  return (
    <Layout
      title="Logs list"
    >
      <LogsContent />
    </Layout>
  );
}
